export default "__VITE_ASSET__DwBveUSQ__"